import { render, staticRenderFns } from "./EventiGrid.vue?vue&type=template&id=2e39731d&"
import script from "./EventiGrid.vue?vue&type=script&lang=ts&"
export * from "./EventiGrid.vue?vue&type=script&lang=ts&"
import style0 from "./EventiGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports